(function () {
  document.querySelectorAll('.g_faq-question').forEach((question) => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling;
      const isActive = question.classList.contains('active');

      document.querySelectorAll('.g_faq-question').forEach((q) => {
        q.classList.remove('active');
        q.nextElementSibling.classList.remove('active');
      });

      if (!isActive) {
        question.classList.add('active');
        answer.classList.add('active');
      }
    });
  });
})();